/**
 * Indicatore "Ricontatta" nella riga della lista chat:
 * - scaduto: "Da ricontattare" (arancione), con "ha risposto" se il cliente ha gia' scritto;
 * - non scaduto ma il cliente ha scritto: "Ha risposto" (verde);
 * - in programma: solo l'icona, la data nel suggerimento.
 */
import { BellRing } from 'lucide-react';
import { tip } from '@/components/messages/ChatTooltip';
import { formatRecontactDate } from '@/lib/services/whatsapp/recontactRules';

export interface RecontactRowInfo {
  due: boolean;
  replied: boolean;
  dueAt: string;
  note: string | null;
}

export function RecontactRowBadge({ info }: { info: RecontactRowInfo }) {
  const data = formatRecontactDate(info.dueAt);
  const nota = info.note ? `: ${info.note}` : '';
  if (!info.due && !info.replied) {
    return <BellRing className="w-3 h-3 text-[#9B9A97]" aria-label="Ricontatto in programma" {...tip(`Ricontatto previsto il ${data}${nota}`)} />;
  }
  if (info.due) {
    return (
      <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded text-[9px] font-medium bg-[#FBF3DB] dark:bg-amber-900/20 text-[#D9730D]"
        {...tip(`Promemoria del ${data}${nota}${info.replied ? '. Il cliente ha scritto dopo che l\'hai impostato' : ''}`)}>
        <BellRing className="w-2.5 h-2.5 flex-shrink-0" />
        Da ricontattare{info.replied ? ' · ha risposto' : ''}
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded text-[9px] font-medium bg-emerald-50 dark:bg-emerald-900/20 text-[#0F7B6C]"
      {...tip(`Ha risposto prima del ricontatto previsto il ${data}${nota}`)}>
      <BellRing className="w-2.5 h-2.5 flex-shrink-0" />
      Ha risposto
    </span>
  );
}
